import React, { useState, useEffect, useContext } from 'react';
import io from 'socket.io-client';
import Header from './Header';
import BottomNav from './BottomNav';
import ProgressBar from './ProgressBar';
import MessageBox from './MessageBox'; // Import MessageBox for auto-closure notification
import { useProgressBar } from '../context/ProgressBarContext';
import { useAuth } from '../context/AuthContext'; // Import useAuth
import { useLocation } from 'react-router-dom'; // Import useLocation
import { ThemeContext } from '../context/ThemeContext'; // Import ThemeContext as a named export

import styles from './Layout.module.css';

const Layout = ({ children, layoutDisabled }) => {
  const { progress, isVisible } = useProgressBar();
  const { refreshUser } = useAuth(); // Destructure refreshUser
  const location = useLocation(); // Initialize useLocation
  const { theme } = useContext(ThemeContext); // Use ThemeContext

  const [combinedLossWarning, setCombinedLossWarning] = useState(null); // State for 75% loss warning
  const [autoClosureNotification, setAutoClosureNotification] = useState(null); // State for 90% auto-closure notification

  useEffect(() => {
    document.title = process.env.REACT_APP_NAME;
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const socket = io(process.env.REACT_APP_API_URL || 'http://localhost:5000', {
      auth: {
        token: token
      }
    });

    socket.on('combinedLossWarning', (data) => {
      setCombinedLossWarning(data.message);
    });

    socket.on('autoClosureNotification', (data) => {
      setAutoClosureNotification({ type: 'error', text: data.message });
      refreshUser(); 
    });

    socket.on('connect_error', (err) => {
      // console.error('Socket.IO connection error:', err.message);
    });

    socket.on('combinedLossWarningCleared', () => {
      setCombinedLossWarning(null);
    });

    return () => {
      socket.disconnect();
    };
  }, [refreshUser]);

  const showHeader = location.pathname === '/';

  return (
    <div className={`${styles.layout} ${styles[theme]}`}> {/* Use theme from context */}
      {combinedLossWarning && (
        <div className={styles['combined-loss-warning']}>
          {combinedLossWarning}
        </div>
      )}
      <ProgressBar progress={progress} isVisible={isVisible} />
      {showHeader && <Header isDisabled={layoutDisabled} />} 
      <main className={styles['main-content']}>
        {children}
      </main>
      <BottomNav isDisabled={layoutDisabled} />
      {autoClosureNotification && (
        <MessageBox
          message={autoClosureNotification.text}
          type={autoClosureNotification.type}
          onClose={() => setAutoClosureNotification(null)}
        />
      )}
    </div>
  );
};

export default Layout;